import { BorrowerContractualizationResponse } from "api/quote"
import { Button } from "components/ui/Button"
import { GenericLoading, Sizes as LoaderSizes } from "components/ui/Loader"
import { EyeIcon } from "components/icons/Icons"
import { NsKey } from "enums/NsKey"
import { Sizes } from "enums/sizes"
import { useDynamicTranslation } from "hooks/useDynamicTranslation"
import { usePanel } from "hooks/usePanel"
import { FC, useCallback } from "react"
import { BorrowerQuoteDetails } from "./BorrowerQuoteDetails"

export const BorrowerQuoteHeader: FC<{ borrowerId?: string, globalInfos: BorrowerContractualizationResponse }> = ({ globalInfos, borrowerId }) => {
  const { t } = useDynamicTranslation([NsKey.Contractualization, NsKey.Common])
  const { openPanel } = usePanel()

  const showQuoteDetails = useCallback(() => {
    if (globalInfos)
      openPanel({
        title: t("CONTRACTUALIZATION.TITLE.QUOTE_DETAILS"),
        size: Sizes['3xl']
      },
        <BorrowerQuoteDetails globalInfos={globalInfos} />
      )
  }, [openPanel, globalInfos, t])

  return <div className='flex justify-between items-center'>
    <div className='flex items-center gap-3'>
      <h1 className='text-2xl font-bold text-gray-900'>Devis</h1>
      <div className='w-px h-8 bg-gray-300'></div>
      <div className='bg-primary/10 text-primary px-4 py-2 rounded-lg font-semibold'>
        {
          globalInfos.quoteTabs ?

            `${globalInfos.quoteTabs.find(tab => tab.borrowerId === borrowerId)?.label}`
            :
            <GenericLoading size={LoaderSizes.sm} />
        }
      </div>
      <div className='flex pl-8 space-x-8 items-center'>
        <div className='flex flex-col text-sm text-slate-700'>
          <div>
            Type de contrat
          </div>
          <div className='text-sm text-primary rounded-lg font-semibold'>
            Individuel
          </div>
        </div>
        <div className='w-px h-9 bg-gray-300'></div>
        {
          globalInfos.productOwner ?
            <div className='flex flex-col text-sm text-slate-700'>
              <div>
                Assureur
              </div>
              {
                globalInfos?.productOwner &&
                <div className='text-sm text-primary rounded-lg font-semibold'>
                  {globalInfos?.productOwner}
                </div>
              }
            </div> :
            <div className='bg-primary/10 text-sm text-primary px-4 py-2 rounded-lg font-semibold'>
              Individuel
            </div>
        }
      </div>
    </div>
    <Button color='slate' onClick={showQuoteDetails}>
      <EyeIcon />
      {t("CONTRACTUALIZATION.LABELS.SEE_QUOTE_DETAILS")}
    </Button>
  </div>
}
